// Last-good copy of the PUBLIC market signals (no user data), so a failed API
// call degrades to "showing data saved on <date>" instead of a blank screen
// (UX_FINDINGS U-05). Plain localStorage, guarded: storage may be unavailable.

import type { SeriesSignal } from "../signals/timing";

const KEY = "afm.signals.v1";

export interface CachedSignals {
  savedAt: string; // ISO time the copy was fetched
  series: SeriesSignal[];
}

export function saveSignals(series: SeriesSignal[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ savedAt: new Date().toISOString(), series } satisfies CachedSignals));
  } catch { /* quota / private mode — non-fatal */ }
}

export function loadSignals(): CachedSignals | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as CachedSignals;
    return Array.isArray(v.series) && typeof v.savedAt === "string" ? v : null;
  } catch {
    return null;
  }
}
